import { useEffect, useState } from 'react'

/**
 * Debounce một giá trị — dùng cho search inputs để giảm số lần gọi BE.
 * Trả về giá trị sau `delay` ms khi không có thay đổi mới.
 *
 * @example
 * const [search, setSearch] = useState('')
 * const debouncedSearch = useDebounce(search, 350)
 * useListXxxQuery({ q: debouncedSearch || undefined })
 */
export function useDebounce<T>(value: T, delay = 350): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])
  return debounced
}

export default useDebounce
